import React from "react";
import ReactDOM from "react-dom";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import Traec from "traec";

import { BSCard } from "traec-react/utils/bootstrap";
import BaseFormConnected from "traec-react/utils/form";
import CompanyInviteItem from "./companyInviteItem";

export const companyFields = {
  name: { value: "", class: "col", endRow: true },
  address: { value: "", class: "col", endRow: true },
  address2: { value: "", class: "col", endRow: true },
  suburb: { value: "", class: "col" },
  postcode: { value: "", class: "col" },
  state: { value: "", class: "col" },
  country: { value: "", class: "col", endRow: true }
};

class CompanyInvites extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formParams: {
        stateParams: {},
        fetchParams: {},
        initFields: {}
      },
      fetchedInvites: false
    };

    // Data required from the API for this Component
    this.requiredFetches = [new Traec.Fetch("company_invite_all", "list")];
  }

  componentDidMount() {
    Traec.fetchRequiredFor(this);
  }

  componentDidUpdate() {
    Traec.fetchRequiredFor(this);
  }

  render() {
    let { items } = this.props;
    if (!items || !items.size) {
      return null;
    }

    const itemList = items
      .toList()
      .sortBy(i => i.get("is_request"))
      .map((item, i) => (
        <CompanyInviteItem
          key={i}
          index={i}
          invite={item}
          dispatch={this.props.dispatch}
          onAcceptReject={this.acceptRejectReload}
        />
      ));

    return (
      <BSCard
        widthOffset="col-sm-12"
        title="Company Invites and Requests"
        body={itemList}
        form={
          <BaseFormConnected
            stateParams={this.state.formParams.stateParams}
            fetchParams={this.state.formParams.fetchParams}
            fields={companyFields}
          />
        }
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  items: state.getInPath("entities.companyInvites.byId"),
  isAuthenticated: state.getInPath("auth.isAuthenticated")
});

export default connect(mapStateToProps)(CompanyInvites);
